import * as React from "react";
const SvgFormatSize = props => /*#__PURE__*/React.createElement("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M9 4v3h5v12h3V7h5V4H9Zm-6 8h3v7h3v-7h3V9H3v3Z",
  fill: "currentColor"
}));
export default SvgFormatSize;